<template>
  <div class="info">
    <div class="body">
      <div class="box1">
        <div class="carousel-container">
          <el-carousel  :interval="3000" height="400px">
            <el-carousel-item v-for="(item, index) in images" :key="index ">
              <div class="carousel-container">
                <img :src="item.src" :alt="item.alt" class="carousel-image" />
                <p class="caption">{{item.caption}}</p>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <el-row type="flex" justify="center" style="margin-bottom: 15px">
          <el-col :span="22">
            <div class="title"><img src="@/assets/panelt.png" alt="" >{{ moduInformation.modularName }}</div>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center" style="margin-bottom: 20px">
          <el-col :span="20">
            <span v-html="moduInformation.modularContent"></span>
          </el-col>
        </el-row>

        <div>
          <el-row v-if="fileList.length > 0 ? 1 : 0" type="flex" justify="center" style="margin-bottom: 15px">
            <el-col :span="22">
              <div class="title"><img src="@/assets/panelt.png" alt="">Appendix（Click to download）</div>
            </el-col>
          </el-row>
          <el-row v-if="fileList.length > 0 ? 1 : 0" type="flex" justify="center">
            <el-col :span="20">
              <el-upload action="#" disabled :before-remove="beforeRemove" :on-preview="downLoad" :file-list="fileList">
              </el-upload>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="body-r">

        <!--        参会相关-->
        <div class="important-dates">
<!--          时间-->
          <div class="title"><img src="@/assets/panelt.png" alt="">Important Dates</div>
          <div class="dates-content">
            <div class="dates-item">
              <span>Abstract Submission Deadline</span>
              <p>2025-05-01</p>
            </div>
            <div class="dates-item">
              <span>Conference Date</span>
              <p>2025-11-04</p>
            </div>

          </div>
        </div>
<!--报名相关-->
        <div class="r-button">
          <div class="title"><img src="@/assets/panelt.png" alt="">Express Channels</div>
          <button class="custom-button" @click="toSignUpBody"><i
              style="margin-right: 15px;font-size: 24px;font-weight: bold" class="el-icon-user" ></i> Sign
            up</button>
          <button class="custom-button" @click="toSetHotel"><i
              style="margin-right: 15px;font-size: 24px;font-weight: bold" class="el-icon-office-building"></i>
            Hotel</button>
          <button class="custom-button" @click="toPersonCenter"><i
              style="margin-right: 15px;font-size: 24px;font-weight: bold" class="el-icon-house"></i>Person
            center</button>
          <button class="custom-button" @click="toSignUpBody"><i
              style="margin-right: 15px;font-size: 24px;font-weight: bold" class="el-icon-upload2"></i>Submit
            Abstracts</button>
        </div>
<!--        主办方-->
        <div class="supported">
          <div class="title"><img src="@/assets/panelt.png" alt="">Organizers</div>
          <div class="supported-content">
            <div class="supported-item">
              <span>Organized by</span>
              <p>China Nonferrous Metals Society</p>
            </div>
            <div class="supported-item">
              <span>Co-organized by</span>
              <p>Beijing University of Technology & Henan Academy of Sciences</p>
            </div>
            <div class="supported-item">
              <span>Supported by</span>
              <ul>
                <li>CBMM | Niobium</li>
                <li>CITIC Metal Co., Ltd.</li>
              </ul>
            </div>
        </div>
        </div>
<!--        联系方式-->
        <div class="supported">
          <div class="title"><img src="@/assets/panelt.png" alt="">Contact us</div>
          <div class="supported-content">
            <div class="supported-item">
              <p>Pu Yin</p>
              <p><i>Tel:</i>13601241299</p>
              <p><i>Fax:</i>010-63971451  </p>
              <p>Qin Li</p>
              <p><i>Tel:</i>13167336039</p>
              <p><i>Fax:</i>010-63971458</p>
            </div>
          </div>
      </div>
      </div>

    </div>
    <Footer />
  </div>


</template>

<script>

export default {
  name: "signUpInformation",
  data() {
    return {
      id: '',
      modularId: '',
      moduInformation: {},

      loading: '',

      fileList: [],
      images: [
        {
          src: "http://59.110.106.225:8181/profile/picture/c5a3d6f9-2193-4448-aca5-f263976711d7.jpg",
          alt: "Image 1",
          caption: "中国有色金属学会集体学习党纪学习教育",
        },
        {
          src: "http://59.110.106.225:8181/profile/picture/7bd086fd-6557-4661-a763-9e36f06a04f6.jpg",
          alt: "Image 2",
          caption: "图片描述",
        },
      ],
      dataForm:[],
    }
  },
  methods: {


    beforeRemove() {
      return false
    },
    // 报名参会
    toSignUpBody() {
      // this.$router.push('/signUp/signUpBody',{query:{id:this.id}})
      let routeData = this.$router.resolve(
        {
          path: '/signUp/signUpBody',
          query: { id: this.id }

        });
      window.open(routeData.href, '_self');
    },
    // 酒店预订
    toSetHotel() {
      let routeData = this.$router.resolve(
        {
          path: '/setHotel',
          query: { id: this.id }
        });
      window.open(routeData.href, '_self');
    },
    // 个人中心
    toPersonCenter() {
      let routeData = this.$router.resolve(
        { path: '/person', query: { id: this.id } });
      window.open(routeData.href, '_blank');
    },
    // 上传论文
    toUpload() {
      let routeData = this.$router.resolve(
        {
          path: '/signUpLoad',
          query: { id: this.id }
        });
      window.open(routeData.href, '_self');
    },
    openFullScreen2() {
      this.loading = this.$loading({
        lock: true,
        text: '文件下载中，请稍作等待！',
        spinner: 'el-icon-loading',
        background: 'rgba(0.7)'
      });
    },
    //下载
    downLoad(file) {
      this.openFullScreen2()
      const a = document.createElement('a')
      let url = 'https://member.nfsoc.org.cn:8666' + file.url // 若是不完整的url则需要拼接baseURL
      // const url = file.url // 完整的url则直接使用
      // 这里是将url转成blob地址，
      fetch(url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
        a.href = URL.createObjectURL(blob)
        // console.log(a.href)
        a.download = file.name // 下载文件的名字
        // a.download = url.split('/')[url.split('/').length -1] //
        document.body.appendChild(a)
        a.click()
        this.loading.close();
      })
    },

    //加载
    openFullScreen() {
      this.loading = this.$loading({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0.7)',
      });

    },
    //获取所有导航信息
    async getMenuInformation(modularId) {
      const { data: res } = await this.$http.get('api/conference/confDetailed/user/modular/' + modularId)
      // console.log(res,'导航信息');
      if (res.code === 200) {
        this.moduInformation = res.data
        if (res.data.confModularFileList.length > 0) {
          this.fileList = res.data.confModularFileList.map(item => {
            const listItem = {};
            listItem.name = item.fileName;
            listItem.url = item.filePath;
            return listItem;
          })
          // console.log(this.fileList);
        }
      } else {
        // this.$message.error(res.msg)
      }
      this.loading.close();
    },
    //获取所有信息
    async getInformation() {
      const { data: res } = await this.$http.get('api/conference/confDetailed/user/' + this.id)
      this.poster = res.data.poster
    },
  },
  created() {
    this.id = 17
    this.modularId=40
    // this.modularId = this.$route.query.modularId
    this.getMenuInformation(this.modularId)
  },
  watch: {
    $route: {
      handler() {
        if (this.$route.query.modularId) {
          this.openFullScreen()
          this.getMenuInformation(this.$route.query.modularId)
        }
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>
<style scoped lang="less">
.info {
  display: flex;
  flex-direction: column;
  //margin-top: 30px;
  // width: 1075px;
}

.body {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  min-height: 220px;
  // background-color: white;
  //width: 1200px;
}

.box1 {
  width: 70%;
}
.carousel-container {
  position: relative;
  margin: 5px;
  width: 100%;
  height: 400px;  /* 固定高度，避免图片和文字溢出 */
  overflow: hidden;  /* 防止内容溢出 */
}

.carousel-image {
  width: 98%;
  height: 100%;
  object-fit: cover; /* 确保图片按比例填充容器 */
}

.caption {
  position: absolute;
  bottom: 1px;
  left: 10px;
  color: white;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 14px;
}
/deep/ .el-carousel__indicators { // 指示灯位置
  left: unset;
  transform: unset;
  right: 2%;
}
/deep/ .el-carousel__button { // 默认按钮的颜色大小等
  width: 20px;
  height: 3px;
  border: none;
  border-radius: 20px;
  background: #FFFFFF;
  opacity: 1;
}

/deep/ .is-active .el-carousel__button { // 选中图片的颜色
  background: #14A5FE;
  opacity: 1;
}

.title {
  font-size: 18px;
  width: 80%;
  height: 35px;
  line-height: 35px;
  margin-top: 5px;
  font-family: "Segoe UI", "Helvetica Neue", Arial, sans-serif;
  margin-left: 10px;
  //padding-left: 5px;
  //color: #1da7fe;
  //border-left: solid 6px #1da7fe !important;
  //border-right: solid 3px #1da7fe !important;
  //background-color: #fbfbfb;

  img {
    margin-right: 3px;
  }
}

.body-r {
  margin-top: 10px;
  margin-right: 5px;
  width: 30%;
  border-right: 1px solid #d6d2d2;
  border-left: 1px solid #d6d2d2;
  border-bottom: 1px solid #d6d2d2;
}
.important-dates{
  padding: 5px 10px;
  // margin-top: 10px;
  border-top: 1px solid #d6d2d2;
  //border-bottom: 1px solid #d6d2d2;

}
.dates-content{
  margin: 15px 15px 0;
  .dates-item{
    margin-bottom: 10px;
    span{
      color:#337FE5;
      font-weight: bold;

    }
    p{
      margin: 0;
    }
  }
}
.r-button {
  width: 100%;
  margin-top: 10px;
  padding: 10px;
  text-align: left;
  border-top: 1px solid #d6d2d2;
}

.custom-button {
  margin: 10px 20px;
  width: 80%;
  height: 45px;
  font-size: 20px;
  background-color: white;
  /* 设置背景色 */
  color: #0750B5;
  border: 1px solid #0940C2;
  border-radius: 3px;
  /* 设置边框颜色 */
  transition: 0.5s;
  text-align: left;
  i{
    margin-left: 20px;
  }
}

.custom-button:hover {
  background-color: #0750B5;
  /* 悬停时背景色 */
  border-color: #2E3B91;
  /* 悬停时边框颜色 */
  color: white;
}
.supported{
  padding: 5px 10px;
   margin-left: 10px;
  border-top: 1px solid #d6d2d2;
  //border-bottom: 1px solid #d6d2d2;
}
.supported-content{
  margin: 15px 0;
  .supported-item{
    margin-bottom: 10px;
    margin-left: 10px;
    font-size: 17px;
    span{
      font-weight: bold;
    }
    p{
      margin: 8px 0;
      font-size: 15px;
    }
    i{
      margin-right: 5px;
      color: #337FE5;
    }
  }
}
</style>
